import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Chrome-free shell for the signed-out routes: sign-in, sign-up, password
 * recovery, and the error page.
 *
 * The auth SCREENS themselves are per-portal (see CLAUDE.md > Authentication);
 * this only supplies the page ground.
 */
export const BlankLayout = (): ReactNode => (
  <div className="min-h-screen bg-ds-bg-page">
    <Outlet />
  </div>
);
